import React from 'react';
import styles from './Welcome.module.scss';
import reducer from './welcome-reducer';
import Constant from '../../constants';
import arrow from '../../images/down-arrow.svg';
import wondering from '../../images/wondering.svg';
import building from '../../images/building.svg';

const Welcome = () => {
  return (
    <main>
      <article className={styles.welcomeContainer}>
        <section className={styles.welcomeMsg}>
          <p>{Constant.WELCOME_MSG_I}</p>
          <p>{Constant.WELCOME_MSG_II}</p>
          <p>
            To get started, click on <a>Sign up</a>
          </p>
        </section>
        <section className={styles.welcomeImg}>
          <img className={styles.wonderingImg} src={wondering} />
          <img className={styles.buildingImg} src={building} />
        </section>
      </article>
      <img className={styles.downImg} src={arrow} />
    </main>
  );
};

export default Welcome;
